@use '../../styling/colors.scss' as *;

.MainCardTable {
  display: flex;
  flex-direction: column;
  border-top: 1px solid $theme-color-borders;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  background: $theme-color-sub-background;
  padding: 16px;
}
